<template>
    <div class="bottom mt20">
        <div class="bottom1">
            <div class="content myflex-v">
                <div class="myflex-lv imgBox">
                    <img src="@/assets/img/code1.png" alt="code1" class="code-img">
                    <img src="@/assets/img/code2.png" alt="code1" class="code-img">
                </div>
                <div class="font1Box">
                    <div class="mb10">本站属全民终身学习教育资源共享行动（艺术类）<br/>
                        由北京师范大学中国艺术教育研究中心<br/>
                        中国成人教育协会艺术教育专业委员会&nbsp;&nbsp;联合管理
                    </div>
                    <div class="line1"></div>
                    <div class="mb5">教学合作联系方式</div>
                    <div class="mb5">art@artapp.cn</div>
                </div>
                <div class="marginauto-l jishu text-right">
                    <div class="fon16 mb10"><span>技术支持 | artapp</span></div>
                    <div class="">北京市海淀区学院南路12号京师科技大厦A座</div>
                </div>
            </div>
        </div>
        <div class="bottom2">
            <div class="content myflex-lv flexWrap">©北京归去来兮文化发展有限公司版权所有 
                <a href="https://beian.miit.gov.cn" class="link myflex-v">
                    <img class="gongan" src="@/assets/img/publicSecurity.png"/>
                    京ICP备15051235号-4
                </a>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .bottom{color:#fff;font-size:16px;}
    .line1{width:46px;height:3px;background:#fff;margin:5px 0 5px 0;}
    .code-img{width:100px;margin-right:30px;border:2px solid #fff;}
    .line{width:4px;height:16px;background:#f44933;display:inline-block;margin-right:8px;}
    .jishu{margin-top:87px;}
    .link{color:#fff;text-decoration:none;margin-left:10px;}
    .link:hover{text-decoration:underline;}
    .gongan{height:14px;margin-right:2px;}
    .bottom1{background:$theme-color;padding:35px 20px;}
    .bottom2{background:#333;color:#fff;text-align:center;height:50px;line-height:50px;}
    @media screen and(max-width:1000px){
        .content{flex-wrap:wrap;}
        .imgBox{width:100%;}
        .imgBox:last-child{margin-right:0;}
        .font1Box{width:100%;text-align:center;margin:30px 0;}
        .line1{margin:5px auto;}
        .jishu{margin:0 auto;text-align:center !important;}
        .bottom2{height:auto;line-height:1.4;padding:10px;}
    }
</style>

<script>
export default {
    name: "top",
    components: {
    },
    data(){
        return {

        }
    }
}
</script>